import React, { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar, { COLLAPSED_W, EXPANDED_W } from "./Sidebar";
import { useUIStore } from "../store/uiStore";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import AppBackground from "../components/AppBackground";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

export default function AppLayout() {
  const location = useLocation();
  const pinned = useUIStore((s) => s.sidebarPinned);
  const theme = useUIStore((s) => s.theme);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 768);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  const isWorkspace = location.pathname.startsWith("/app/workspace") || location.pathname === "/app/stempeluhr";
  const isCrm = location.pathname === "/app/crm";
  // Bautagesbericht-Editor + DailyReports-Liste sind mobil-optimiert — auf Mobile
  // KEINE Desktop-Sidebar einblenden (sonst überdeckt sie die mobile Ansicht).
  const isBautagesbericht = /^\/app\/projekte\/[^/]+\/berichte(\/.*)?$/.test(location.pathname);
  // Nina Studio (nur /app/nina — NICHT /app/nina/visuals, /app/nina/gaeste, ...):
  // Ronny-Brief Feb 2026 §1: interne Nina bekommt keinen globalen TGAone-Sidebar.
  const isNinaStudio = location.pathname === "/app/nina";
  // Nina mobile: auch die Sub-Admin-Routen bleiben ohne Sidebar auf Mobile.
  const isNina = location.pathname === "/app/nina" || location.pathname.startsWith("/app/nina/");
  const hideSidebar = isNinaStudio || (isMobile && (isWorkspace || isBautagesbericht || isNina));
  const ml = pinned ? EXPANDED_W : COLLAPSED_W;

  const isStundenkonten = location.pathname === "/app/stundenkonten";

  return (
    <QueryClientProvider client={queryClient}>
      <AppBackground />
      <div
        className={`${hideSidebar ? "" : "erp-compact "}${isNinaStudio ? "h-dvh overflow-hidden" : "min-h-screen"} relative`}
        style={{ backgroundColor: "transparent" }}
      >
        {!hideSidebar && <Sidebar />}
        <div
          style={hideSidebar ? undefined : { marginLeft: ml, transition: "margin-left 0.2s ease" }}
          className={(isCrm || isStundenkonten) ? "h-screen" : isNinaStudio ? "h-full" : ""}
        >
          <main
            className={
              isNinaStudio ? "h-full overflow-hidden"
              : hideSidebar ? ""
              : (isCrm || isStundenkonten) ? "h-full flex flex-col overflow-hidden px-4 py-3"
              : "px-4 py-3"
            }
          >
            <Outlet />
          </main>
        </div>
      </div>
    </QueryClientProvider>
  );
}
